/* Sauvé Studio. Native shopping remains independent of this enhancement. */
(() => {
  if (window.__sauveStudio) return;
  window.__sauveStudio = true;
  const preference = matchMedia('(prefers-reduced-motion: reduce)');
  const explorers = new Map();
  const scenes = new Map();
  const g = window.gsap;
  const st = window.ScrollTrigger;
  if (g && st) g.registerPlugin(st);

  function makeExplorer(root) {
    if (explorers.has(root)) return;
    const tabs = [...root.querySelectorAll('[data-stone-key]')];
    const panels = [...root.querySelectorAll('[data-stone-panel]')];
    if (!tabs.length || tabs.length !== panels.length || tabs.some(t => !panels.some(p => p.dataset.stonePanel === t.dataset.stoneKey))) return;
    const abort = new AbortController();
    let transition;
    const clearTransition = () => {
      transition?.kill();
      panels.forEach(panel => panel.querySelectorAll('.su-stone-panel__image img,h3').forEach(el => {
        el.style.removeProperty('transform'); el.style.removeProperty('opacity');
      }));
    };
    function activate(key, { focus = false, announce = true, updateHash = true } = {}) {
      const tab = tabs.find(t => t.dataset.stoneKey === key);
      if (!tab) return;
      clearTransition();
      tabs.forEach(t => { const active = t === tab; t.setAttribute('aria-selected', String(active)); t.tabIndex = active ? 0 : -1; });
      panels.forEach(p => { p.hidden = p.dataset.stonePanel !== key; });
      const panel = panels.find(p => !p.hidden);
      root.dataset.activeStone = key;
      if (focus) tab.focus({ preventScroll: true });
      if (announce) root.querySelector('[data-stone-status]').textContent = tab.textContent.trim().replace(/↗/g,'') + ': ' + panel.querySelector('h3').textContent.trim();
      if (updateHash) history.replaceState(history.state, '', '#studio-' + key);
      if (g && !preference.matches && announce) {
        const image = panel.querySelector('.su-stone-panel__image img');
        const title = panel.querySelector('h3');
        transition = g.timeline({ onComplete: clearTransition });
        if (image) transition.fromTo(image, { scale: .965, opacity: .88 }, { scale: 1, opacity: 1, duration: .48, ease: 'power2.out' }, 0);
        if (title) transition.fromTo(title, { y: 12, opacity: .85 }, { y: 0, opacity: 1, duration: .38, ease: 'power2.out' }, .04);
      }
    }
    root.querySelector('[data-stone-tabs]').setAttribute('role','tablist');
    tabs.forEach((tab,index) => {
      const panel = panels.find(p => p.dataset.stonePanel === tab.dataset.stoneKey);
      tab.setAttribute('role','tab'); tab.setAttribute('aria-controls', panel.id);
      panel.setAttribute('role','tabpanel');
      tab.addEventListener('click', event => {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault(); activate(tab.dataset.stoneKey);
      }, { signal: abort.signal });
      tab.addEventListener('keydown', event => {
        let next;
        if (['ArrowRight','ArrowDown'].includes(event.key)) next = (index + 1) % tabs.length;
        else if (['ArrowLeft','ArrowUp'].includes(event.key)) next = (index - 1 + tabs.length) % tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = tabs.length - 1;
        else if (event.key === ' ') next = index;
        else return;
        event.preventDefault(); activate(tabs[next].dataset.stoneKey, { focus: true });
      }, { signal: abort.signal });
    });
    const requested = location.hash.replace(/^#studio-/, '');
    const initial = tabs.some(t => t.dataset.stoneKey === requested) ? requested : tabs[0].dataset.stoneKey;
    root.classList.add('is-enhanced');
    activate(initial, { announce: false, updateHash: false });
    preference.addEventListener('change', clearTransition, { signal: abort.signal });
    explorers.set(root, { activate, destroy() { abort.abort(); clearTransition(); panels.forEach(p => { p.hidden = false; }); root.classList.remove('is-enhanced'); } });
  }

  function makeScene(root) {
    if (!g || !st || scenes.has(root)) return;
    const mm = g.matchMedia();
    mm.add('(prefers-reduced-motion: no-preference)', () => {
      root.querySelectorAll('[data-studio-reveal]').forEach(el => {
        if (el.getBoundingClientRect().top < innerHeight) return;
        g.fromTo(el, { y: 20, opacity: .85 }, { y: 0, opacity: 1, duration: .7, ease:'power3.out', immediateRender: false, scrollTrigger: { trigger:el, start:'top 92%', once:true } });
      });
      const paths = [...root.querySelectorAll('[data-studio-draw] path')];
      if (paths.length) g.fromTo(paths,
        { strokeDasharray:(_,p) => p.getTotalLength(), strokeDashoffset:(_,p) => p.getTotalLength() },
        { strokeDashoffset:0, duration:1.15, stagger:.06, ease:'power2.inOut', scrollTrigger:{ trigger:root, start:'top 85%', once:true } });
    }, root);
    mm.add('(min-width: 1000px) and (prefers-reduced-motion: no-preference)', () => {
      const ornament = root.querySelector('.su-hero__drawing');
      if (ornament) g.to(ornament, { y:35, rotation:18, ease:'none', scrollTrigger:{ trigger:root,start:'top top',end:'bottom top',scrub:.6 } });
    }, root);
    scenes.set(root, mm);
  }
  function init(root) {
    root.querySelectorAll('[data-stone-explorer]').forEach(makeExplorer);
    root.querySelectorAll('[data-studio-scene]').forEach(makeScene);
  }
  init(document);
  // Keep the floating help trigger off actual link hit areas; do not remove the app.
  if (document.querySelector('.su-hero')) {
    let queued = false;
    const reconcileChat = () => {
      queued = false;
      const widget = document.querySelector('#carthike-chat-button-container');
      if (!widget || widget.contains(document.activeElement)) return;
      const r = widget.getBoundingClientRect();
      const covered = r.width > 0 && [...document.querySelectorAll('.su-scope a')].some(link => {
        const b = link.getBoundingClientRect();
        return b.width > 0 && b.height > 0 && b.bottom > r.top && b.top < r.bottom && b.right > r.left && b.left < r.right;
      });
      document.body.classList.toggle('su-chat-clear', covered);
    };
    const scheduleChat = () => { if (!queued) { queued = true; requestAnimationFrame(reconcileChat); } };
    addEventListener('scroll', scheduleChat, { passive:true });
    addEventListener('resize', scheduleChat, { passive:true });
    addEventListener('load', scheduleChat);
    document.addEventListener('focusout', scheduleChat);
    const watchWidget = () => {
      const widget = document.querySelector('#carthike-chat-button-container');
      if (!widget) return false;
      if ('ResizeObserver' in window) new ResizeObserver(scheduleChat).observe(widget);
      widget.addEventListener('transitionend', scheduleChat);
      widget.addEventListener('animationend', scheduleChat);
      scheduleChat();
      return true;
    };
    if (!watchWidget()) {
      const waiting = new MutationObserver(() => { if (watchWidget()) waiting.disconnect(); });
      waiting.observe(document.body, { childList:true, subtree:true });
    }
    scheduleChat();
  }
  document.addEventListener('click', event => {
    const link = event.target instanceof Element ? event.target.closest('[data-stone-jump]') : null;
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const root = document.querySelector('[data-stone-explorer]');
    const controller = explorers.get(root);
    if (!controller) return;
    event.preventDefault();
    controller.activate(link.dataset.stoneJump, { focus: true });
    const header = document.querySelector('#header-component');
    window.scrollTo({ top:root.getBoundingClientRect().top + scrollY - (header?.getBoundingClientRect().height || 80) - 12, behavior:preference.matches ? 'instant' : 'smooth' });
  });
  window.addEventListener('hashchange', () => {
    const key=location.hash.replace(/^#studio-/,'');
    explorers.forEach(controller => controller.activate(key, { updateHash:false }));
  });
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    explorers.forEach((controller,root) => { if (event.target.contains(root)) { controller.destroy(); explorers.delete(root); } });
    scenes.forEach((mm,root) => { if (event.target.contains(root)) { mm.revert(); scenes.delete(root); } });
  });
})();
